<template>
    <div class="admin-category-page">
        <div class="d-flex justify-content-between mb-3">
            <h3 class="mini-title">منطقه ها</h3>    
            <router-link to="/admin/add/district"><button class="purple-btn">افزودن</button></router-link>
        <router-view></router-view>
        </div>
        <table>
            <tr>
                <th>نام</th>
                <th>َشهر</th>
                <th>ابزار</th>
            </tr>
            <show-city @deleteMe="remove" v-for="(c,i) in districts" :key="i" :theCity="c" ></show-city>
        </table>
    </div> 
</template>
<script>
import Service from "../../../utils/admin-service"
import {ref,computed,onMounted,inject} from "@vue/composition-api"
import ShowCity from "./partials/city"
export default {
    components:{
        ShowCity
    },
    setup(){
        const theService = computed(()=>{
            return Service(false)
        })
        const global = inject('global')
        const districts = ref(null)
        onMounted(() => {
            
            theService.value.receive('admin/district/1',{},getDistricts,errorHandler)
        })

        const errorHandler = (e)=>{

        }
        const getDistricts = (status,data) => {
            districts.value = data.data
        }

        const remove = (id) => {
            theService.value.remove('admin/district/' + id,{},successfullReq,failedReq)
        }

        const successfullReq = (s,d) => {
            if(s == 200){
                global.alertToggle('درخواست موفقیت آمیز بود!')
                theService.value.receive('admin/district/1',{},getDistricts,errorHandler)
            }
        }

        const failedReq = (e) => {
            global.alertToggle('درخواست نا موفق!')
        }

        return {districts,remove}
    }
}
</script>
<style scoped>
.admin-category-page{
    padding:3rem 3rem 1rem 3rem;
}
table{
    width: 100%;
    border:1px solid rgb(218, 218, 218);
}
th{
    border:1px solid rgb(218, 218, 218);
}
tr{
    width:100%;
    border:1px solid rgb(218, 218, 218);
    text-align: center;
}
</style>